// Returns current US Eastern time market status
// Pre-Market:  04:00 AM - 09:29 AM ET
// Market:      09:30 AM - 03:59 PM ET
// Post-Market: 04:00 PM - 07:59 PM ET
// Closed:      08:00 PM - 03:59 AM ET

export function getMarketStatus() {
  // Get current time in US Eastern
  const now = new Date();
  const etString = now.toLocaleString('en-US', { timeZone: 'America/New_York' });
  const et = new Date(etString);

  const hours = et.getHours();
  const minutes = et.getMinutes();
  const day = et.getDay(); // 0=Sun, 6=Sat
  const totalMinutes = hours * 60 + minutes;

  // Weekend — market closed
  if (day === 0 || day === 6) {
    return { status: 'Closed', color: 'gray', label: 'Closed' };
  }

  // Pre-Market: 4:00 AM (240) to 9:29 AM (569)
  if (totalMinutes >= 240 && totalMinutes <= 569) {
    return { status: 'pre-market', color: 'yellow', label: 'Pre-Market' };
  }

  // Market: 9:30 AM (570) to 3:59 PM (959)
  if (totalMinutes >= 570 && totalMinutes <= 959) {
    return { status: 'market', color: 'green', label: 'Market Open' };
  }

  // Post-Market: 4:00 PM (960) to 7:59 PM (1199)
  if (totalMinutes >= 960 && totalMinutes <= 1199) {
    return { status: 'post-market', color: 'orange', label: 'Post-Market' };
  }

  // Closed: 8:00 PM to 3:59 AM
  return { status: 'closed', color: 'gray', label: 'Closed' };
}

export function getStatusDotColor(color) {
  switch (color) {
    case 'green': return 'bg-green-500';
    case 'yellow': return 'bg-yellow-500';
    case 'orange': return 'bg-orange-500';
    default: return 'bg-gray-400';
  }
}

export function getStatusTextColor(color) {
  switch (color) {
    case 'green': return 'text-green-600';
    case 'yellow': return 'text-yellow-600';
    case 'orange': return 'text-orange-600';
    default: return 'text-gray-500';
  }
}
